import { InputMasks } from 'common/fields/input-field';
import * as Yup from 'yup';

export const model = {
  username: {
    label: '',
    type: 'text',
    name: 'username',
    withBorder: false,
    placeholder: 'Username',
    mask: InputMasks.username,
  },
};
export const validationSchema = () =>
  Yup.object().shape({
    [model.username.name]: Yup.string()
      .min(2, 'Invalid surname' as string)
      .required('Name is required' as string)
      .matches(/^[a-zA-Z0-9]+$/, 'Invalid name' as string),
  });

export const initialValues = (data: any) => {
  return {
    [model.username.name]: data?.username ?? '',
  };
};
